import { render, staticRenderFns } from "./BuyingOrder.vue?vue&type=template&id=868dd196"
import script from "./BuyingOrder.vue?vue&type=script&lang=js"
export * from "./BuyingOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports